import { capitalize } from "../../../utilities";

const ProductCardDetail = ({ item }) => {
  const textWithDots = {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
  };

  const itemName = item?.name || "";
  return (
    <div className="m-1" style={textWithDots}>
      <span
        className="card-title text-capitalize"
        style={{ fontSize: "14px", color: "black", fontWeight: "500" }}
      >
        {item?.is_hashtag && itemName.charAt(0) !== "#"
          ? `#${capitalize(itemName)}`
          : capitalize(itemName)}
      </span>
    </div>
  );
};

export default ProductCardDetail;
